import { axiosInstance } from './axios';
import { REACT_APP_API_SERVER_URL } from './constants';

export const getLeasingOffersDetails = async (params: { id: number }) => {
  const response = await axiosInstance.get(
    `${REACT_APP_API_SERVER_URL}/api/leasing-offer/${params.id}/details`,
  );

  return response.data;
};
